/* Nothing Legal: predictive search.
 * Attaches an as-you-type suggestions dropdown to every search input ([name="q"]).
 * Uses Shopify's /search/suggest.json endpoint (products only).
 */
(function () {
  function debounce(fn, ms) {
    var t;
    return function () {
      var ctx = this, args = arguments;
      clearTimeout(t);
      t = setTimeout(function () { fn.apply(ctx, args); }, ms);
    };
  }

  function esc(s) {
    return String(s == null ? "" : s)
      .replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
  }

  function attach(input) {
    var form = input.closest("form");
    if (!form) return;
    if (getComputedStyle(form).position === "static") form.style.position = "relative";

    var wrap = document.createElement("div");
    wrap.className = "predictive-results";
    wrap.style.display = "none";
    form.appendChild(wrap);

    function hide() { wrap.style.display = "none"; }
    function show() { if (wrap.innerHTML) wrap.style.display = "block"; }

    var run = debounce(function () {
      var q = input.value.trim();
      if (q.length < 2) { wrap.innerHTML = ""; hide(); return; }
      var url = window.theme.url("search/suggest.json") + "?q=" + encodeURIComponent(q) +
                "&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last";
      fetch(url, { headers: { Accept: "application/json" } })
        .then(function (r) { return r.json(); })
        .then(function (data) {
          var products = (((data.resources || {}).results || {}).products) || [];
          if (!products.length) {
            wrap.innerHTML = '<div class="ps-empty">' + esc(window.theme.strings.noMatches) + "</div>";
            show();
            return;
          }
          wrap.innerHTML = products.map(function (p) {
            var img = p.image || (p.featured_image && p.featured_image.url) || "";
            // suggest.json returns price as a decimal string ("42.00"), so format it in the shopper's currency.
            var price = p.price ? '<span class="ps-price">' + esc(window.theme.formatMoney(Math.round(parseFloat(p.price) * 100))) + "</span>" : "";
            return '<a href="' + esc(p.url) + '" class="ps-item">' +
                     (img ? '<img src="' + esc(img) + '" class="ps-thumb" alt="">' : '<span class="ps-thumb"></span>') +
                     '<span class="ps-title">' + esc(p.title) + "</span>" + price +
                   "</a>";
          }).join("");
          show();
        })
        .catch(hide);
    }, 220);

    input.addEventListener("input", run);
    input.addEventListener("focus", show);
    input.addEventListener("blur", function () { setTimeout(hide, 180); });
  }

  function init() {
    var inputs = document.querySelectorAll('input[name="q"]');
    for (var i = 0; i < inputs.length; i++) attach(inputs[i]);
  }

  if (document.readyState !== "loading") init();
  else document.addEventListener("DOMContentLoaded", init);
})();
